import { Component, OnDestroy, OnInit } from "@angular/core";
import { PatternService } from "../../services/pattern.service";
import {
  fadeInDownOnEnterAnimation,
  fadeOutOnLeaveAnimation,
} from "angular-animations";
import { ConfiguratorService } from "../../services/configurator.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AnalyticsService } from "../../services/analytics.service";
import { asset } from "../../helpers/asset.helper";

export const patternFadeIn = fadeInDownOnEnterAnimation();
export const patternFadeOut = fadeOutOnLeaveAnimation();

@Component({
  selector: "app-pattern",
  templateUrl: "./pattern.component.html",
  styleUrls: ["./pattern.component.scss"],
  animations: [patternFadeIn, patternFadeOut],
})
export class PatternComponent implements OnInit, OnDestroy {
  patternsData = null;
  lang = "";
  hasScrolled = false;
  subscribtions: Subscription = new Subscription();

  constructor(
    private patternService: PatternService,
    private confService: ConfiguratorService,
    private translate: TranslateService,
    public analytics: AnalyticsService,
    private router: Router,
  ) {
    this.lang = translate.currentLang;
    this.subscribtions.add(
      translate.onLangChange.subscribe((data) => {
        this.lang = data.lang;
      }),
    );
  }

  ngOnInit() {
    this.analytics.trackView(
      "/configurator/series",
      "Конфигуратор - Выбор серии",
    );
    this.confService.refresh();
    this.patternService.getPatternsList().then((data) => {
      this.patternsData = data;

      this.patternsData[0].patterns.push({
        code: "TANDEM",
        title: {
          ua: 'Насос секційний серії "K"',
          ru: 'Насос секционный серии "K"',
          en: 'Multiple pumps series K',
        },
        title_image: {
          ua: asset("assets/img/multipump.png"),
          ru: asset("assets/img/multipump.png"),
          en: asset("assets/img/multipump.png"),
        },
        image: {
          ua: asset("assets/img/multipump_big.png"),
          ru: asset("assets/img/multipump_big.png"),
          en: asset("assets/img/multipump_big.png"),
        },
      });
    });
  }

  /**
   * Спрацьовує, коли завершується анімація кожної картки
   */
  onAnimationDone(isLast: boolean) {
    // Якщо це найостаніший елемент на сторінці і ми ще не скролили — запускаємо
    if (isLast && !this.hasScrolled) {
      this.hasScrolled = true;
      this.scrollToAnchor();
    }
  }

  scrollToAnchor() {
    // Зчитуємо якір з URL (видаляємо решітку та декодуємо кирилицю, якщо вона там буде)
    const hash = window.location.hash ? decodeURIComponent(window.location.hash.replace('#', '')) : null;

    if (!hash) return;

    // Шукаємо елемент на сторінці (наш <div [id]="group.code" class="title-anchor">)
    const element = document.getElementById(hash);

    if (element) {
      // Динамічно міряємо висоту шапки сайту
      const header = document.querySelector('.header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;

      // Рахуємо чисту позицію елемента на сторінці відносно верху вікна
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

      // Віднімаємо висоту шапки + додаємо невеликий красивий відступ у 15px, щоб заголовок не прилипав до шапки
      const offsetPosition = elementPosition - headerHeight - 15;

      // Запускаємо нативний плавний скрол браузера
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }

  runConfigurator(code) {
    if (code === "TANDEM") {
      this.router.navigate(["/tandem"]);
    } else {
      this.router.navigate(["/series/" + code]);
    }
  }

  ngOnDestroy() {
    this.subscribtions.unsubscribe();
  }
}
